import { render } from "./GerenciarEquipesCampeonatoView.vue?vue&type=template&id=5278f8ec&scoped=true"
import script from "./GerenciarEquipesCampeonatoView.vue?vue&type=script&lang=js"
export * from "./GerenciarEquipesCampeonatoView.vue?vue&type=script&lang=js"

import "./GerenciarEquipesCampeonatoView.vue?vue&type=style&index=0&id=5278f8ec&scoped=true&lang=css"
import "./GerenciarEquipesCampeonatoView.vue?vue&type=style&index=1&id=5278f8ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5278f8ec"]])

export default __exports__